var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('h1',{staticClass:"text-center mb-0"},[_vm._v("Terms and Conditions")]),_c('div',[_c('List')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }